import { ENVIRONMENTS } from "../shared/constants";
const constructGetter = function (value: string) {
  return function () {
    return value;
  };
};

function getAppConfig(env: ENVIRONMENTS) {
  switch (env) {
    case ENVIRONMENTS.DEV: {
      const learnerEndpoint = "learning-service-dev.pearson.com";
      const graphqlEndpoint = "graphql-learning-service-dev.pearson.com";
      return {
        getCSGURL: constructGetter("https://content-service-qa.stg-prsn.com"),
        getLearnerGraphqlEndpoint: constructGetter("https://" + graphqlEndpoint + "/graphql"),
        getLearnerWebsocketURL: constructGetter("wss://" + learnerEndpoint + "/socket"),
        getPIClientID: constructGetter("oX5Vm6SEEeSi5QBEAU0081tx20UHE469"),
        getPILoginURL: constructGetter("https://login-stg.pearson.com/v1/piapi-int/login"),
        getGTMAuth: constructGetter("RAFSvAg1n6HG6mFYuU0s3w"),
        getGTMPreview: constructGetter("env-3"),
        getLaunchDarklyClientId: constructGetter("5fa470392368f008d07dd711"),
        getLearnspaceURL: constructGetter("https://dev-learn.bronte.dev-prsn.com"),
        getNRAccountId: constructGetter("693300"),
        getNRAgentId: constructGetter("646263374"),
        getNRLicenseKey: constructGetter("d6db832bf0"),
        getOnDemandlearnerEndpoint: constructGetter(
          "https://" + graphqlEndpoint + "/r/on-demand/get-cohort-id",
        ),
        getPendoApiKey: constructGetter("73a611a9-ac00-4aff-5699-0e400605bf6c"),
      };
    }
    case ENVIRONMENTS.QA: {
      const learnerEndpoint = "learning-service-qaint.pearson.com";
      const graphqlEndpoint = "graphql-learning-service-qaint.pearson.com";
      return {
        getCSGURL: constructGetter("https://content-service-qa.stg-prsn.com"),
        getLearnerGraphqlEndpoint: constructGetter("https://" + graphqlEndpoint + "/graphql"),
        getLearnerWebsocketURL: constructGetter("wss://" + learnerEndpoint + "/socket"),
        getPIClientID: constructGetter("oX5Vm6SEEeSi5QBEAU0081tx20UHE469"),
        getPILoginURL: constructGetter("https://login-stg.pearson.com/v1/piapi-int/login"),
        getGTMAuth: constructGetter("RAFSvAg1n6HG6mFYuU0s3w"),
        getGTMPreview: constructGetter("env-3"),
        getLaunchDarklyClientId: constructGetter("5f48dd1158b578095c12a30f"),
        getLearnspaceURL: constructGetter("https://learn-bronte-qaint.pearson.com"),
        getNRAccountId: constructGetter("693300"),
        getNRAgentId: constructGetter("646263374"),
        getNRLicenseKey: constructGetter("d6db832bf0"),
        getOnDemandlearnerEndpoint: constructGetter(
          "https://" + graphqlEndpoint + "/r/on-demand/get-cohort-id",
        ),
        getPendoApiKey: constructGetter("73a611a9-ac00-4aff-5699-0e400605bf6c"),
      };
    }
    case ENVIRONMENTS.PPE: {
      const learnerEndpoint = "learning-service-ppe.pearson.com";
      const graphqlEndpoint = "graphql-learning-service-ppe.pearson.com";
      return {
        getCSGURL: constructGetter("https://content-service-perf.stg-prsn.com"),
        getLearnerGraphqlEndpoint: constructGetter("https://" + graphqlEndpoint + "/graphql"),
        getLearnerWebsocketURL: constructGetter("wss://" + learnerEndpoint + "/socket"),
        getPIClientID: constructGetter("oX5Vm6SEEeSi5QBEAU0081tx20UHE469"),
        getPILoginURL: constructGetter("https://login-ppe.pearson.com/v1/piapi-pqa/login"),
        getGTMAuth: constructGetter("Q9O-rqpcZufxlu8kc5oAtQ"),
        getGTMPreview: constructGetter("env-286"),
        getLaunchDarklyClientId: constructGetter("5fa470802368f008d07dd727"),
        getLearnspaceURL: constructGetter("https://learn-bronte-ppe.pearson.com"),
        getNRAccountId: constructGetter("693300"),
        getNRAgentId: constructGetter("646263374"),
        getNRLicenseKey: constructGetter("d6db832bf0"),
        getOnDemandlearnerEndpoint: constructGetter(
          "https://" + graphqlEndpoint + "/r/on-demand/get-cohort-id",
        ),
        getPendoApiKey: constructGetter("73a611a9-ac00-4aff-5699-0e400605bf6c"),
      };
    }
    case ENVIRONMENTS.PROD: {
      const learnerEndpoint = "learning-service.pearson.com";
      const graphqlEndpoint = "graphql-learning-service.pearson.com";
      return {
        getCSGURL: constructGetter("https://content-service.prd-prsn.com"),
        getLearnerGraphqlEndpoint: constructGetter("https://" + graphqlEndpoint + "/graphql"),
        getLearnerWebsocketURL: constructGetter("wss://" + learnerEndpoint + "/learn"),
        getPIClientID: constructGetter("hQ8ZsSZoIjyl8chQLgo7dB7fAlGIFvVG"),
        getPILoginURL: constructGetter("https://login.pearson.com/v1/piapi/login"),
        getGTMAuth: constructGetter("BZDe-AMDFM0MIVRf42LnxA"),
        getGTMPreview: constructGetter("env-1"),
        getLaunchDarklyClientId: constructGetter("5f48dd1158b578095c12a310"),
        getLearnspaceURL: constructGetter("https://learning.pearson.com"),
        getNRAccountId: constructGetter("1322480"),
        getNRAgentId: constructGetter("664913296"),
        getNRLicenseKey: constructGetter("d527718953"),
        getOnDemandlearnerEndpoint: constructGetter(
          "https://" + graphqlEndpoint + "/r/on-demand/get-cohort-id",
        ),
        getPendoApiKey: constructGetter("73a611a9-ac00-4aff-5699-0e400605bf6c"),
      };
    }
    case ENVIRONMENTS.STG: {
      const learnerEndpoint = "learning-service-stg.pearson.com";
      const graphqlEndpoint = "graphql-learning-service-stg.pearson.com";
      return {
        getCSGURL: constructGetter("https://content-service-qa.stg-prsn.com"),
        getLearnerGraphqlEndpoint: constructGetter("https://" + graphqlEndpoint + "/graphql"),
        getLearnerWebsocketURL: constructGetter("wss://" + learnerEndpoint + "/socket"),
        getPIClientID: constructGetter("oX5Vm6SEEeSi5QBEAU0081tx20UHE469"),
        getPILoginURL: constructGetter("https://login-stg.pearson.com/v1/piapi-int/login"),
        getGTMAuth: constructGetter("RAFSvAg1n6HG6mFYuU0s3w"),
        getGTMPreview: constructGetter("env-3"),
        getLaunchDarklyClientId: constructGetter("5fa470392368f008d07dd711"),
        getLearnspaceURL: constructGetter("https://learn-bronte-stg.pearson.com"),
        getNRAccountId: constructGetter("693300"),
        getNRAgentId: constructGetter("646263374"),
        getNRLicenseKey: constructGetter("d6db832bf0"),
        getOnDemandlearnerEndpoint: constructGetter(
          "https://" + graphqlEndpoint + "/r/on-demand/get-cohort-id",
        ),
        getPendoApiKey: constructGetter("73a611a9-ac00-4aff-5699-0e400605bf6c"),
      };
    }
  }
}

export default getAppConfig;
